//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { baseUrl } from '@/config';

class _AdminClient {

    

                
            getSyncConfigs(showSpinner = true): Promise<OM.SyncConfig[]> {
                        return CommonServices.defaultGet<OM.SyncConfig[]>(baseUrl + 'api/Admin/GetSyncConfigs',{  }, showSpinner);

                    }
    

                
            getSyncConfig(
                identifier?:string,showSpinner = true): Promise<OM.SyncConfig> {
                        return CommonServices.defaultGet<OM.SyncConfig>(baseUrl + 'api/Admin/GetSyncConfig',{ identifier }, showSpinner);

                    }
    

                
            saveSyncConfig(
                item:OM.SyncConfig,showSpinner = true): Promise<OM.SyncConfig> {
                        return CommonServices.defaultPost<OM.SyncConfig>(baseUrl + 'api/Admin/SaveSyncConfig', item,{}, showSpinner );

                    }
    

                
            getSyncStates(showSpinner = true): Promise<OM.SyncStateSummary[]> {
                        return CommonServices.defaultGet<OM.SyncStateSummary[]>(baseUrl + 'api/Admin/GetSyncStates',{  }, showSpinner);

                    }
    

                
            getSyncState(
                identifier?:string,showSpinner = true): Promise<OM.SyncState> {
                        return CommonServices.defaultGet<OM.SyncState>(baseUrl + 'api/Admin/GetSyncState',{ identifier }, showSpinner);

                    }
    

                
            getOnOfficeEvent(
                syncStateIdentifier?:string,
                onOfficeId?:number,showSpinner = true): Promise<OM.ReadCalendarEvent> {
                        return CommonServices.defaultGet<OM.ReadCalendarEvent>(baseUrl + 'api/Admin/GetOnOfficeEvent',{ syncStateIdentifier, onOfficeId }, showSpinner);

                    }
    

                
            getGoogleEvent(
                syncStateIdentifier?:string,
                googleId?:string,
                calendarId?:string,showSpinner = true): Promise<OM.Event> {
                        return CommonServices.defaultGet<OM.Event>(baseUrl + 'api/Admin/GetGoogleEvent',{ syncStateIdentifier, googleId, calendarId }, showSpinner);

                    }
    

                
            getMarketplaceActivations(showSpinner = true): Promise<OM.MarketplaceActivation[]> {
                        return CommonServices.defaultGet<OM.MarketplaceActivation[]>(baseUrl + 'api/Admin/GetMarketplaceActivations',{  }, showSpinner);

                    }
    

                
            getMarketplaceActivation(
                identifier?:string,showSpinner = true): Promise<OM.MarketplaceActivation> {
                        return CommonServices.defaultGet<OM.MarketplaceActivation>(baseUrl + 'api/Admin/GetMarketplaceActivation',{ identifier }, showSpinner);

                    }
    

                
            setMarketplaceActivationUserId(
                identifier?:string,
                userId?:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/SetMarketplaceActivationUserId',{ identifier, userId }, showSpinner);

                    }
    }

export let AdminClient = new _AdminClient();

class _GoogleCalendarClient {

    

                
            getCalendarsOfUser(
                onOfficeUserId?:string,
                onOfficeWebUserId?:string,showSpinner = true): Promise<OM.NameId[]> {
                        return CommonServices.defaultGet<OM.NameId[]>(baseUrl + 'api/GoogleCalendar/GetCalendarsOfUser',{ onOfficeUserId, onOfficeWebUserId }, showSpinner);

                    }
    

                
            getGroups(
                onOfficeUserId?:string,
                onOfficeWebUserId?:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/GoogleCalendar/GetGroups',{ onOfficeUserId, onOfficeWebUserId }, showSpinner);

                    }
    

                
            getGoogleGroupUserPair(
                onOfficeUserId?:string,
                onOfficeWebUserId?:string,
                groupEmail?:string,showSpinner = true): Promise<OM.GoogleGroupUsersPair> {
                        return CommonServices.defaultGet<OM.GoogleGroupUsersPair>(baseUrl + 'api/GoogleCalendar/GetGoogleGroupUserPair',{ onOfficeUserId, onOfficeWebUserId, groupEmail }, showSpinner);

                    }
    

                
            getEventsOfCalendar(
                onOfficeUserId?:string,
                onOfficeWebUserId?:string,
                calendarId?:string,showSpinner = true): Promise<OM.GoogleEventWithCalendar[]> {
                        return CommonServices.defaultGet<OM.GoogleEventWithCalendar[]>(baseUrl + 'api/GoogleCalendar/GetEventsOfCalendar',{ onOfficeUserId, onOfficeWebUserId, calendarId }, showSpinner);

                    }
    }

export let GoogleCalendarClient = new _GoogleCalendarClient();

class _LocalizedClient {

    

                
            saveAnonymousLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/SaveAnonymousLocalizedValue', item,{}, showSpinner );

                    }
    

                
            saveLocalizedEntity(
                item:OM.LocalizedEntity,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(baseUrl + 'api/Localized/SaveLocalizedEntity', item,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localized/GetAll',{  }, showSpinner);

                    }
    

                
            getEnabledLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localized/GetEnabledLanguages',{  }, showSpinner);

                    }
    

                
            getSupportedLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localized/GetSupportedLanguages',{  }, showSpinner);

                    }
    

                
            saveLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/SaveLocalizedValue', item,{}, showSpinner );

                    }
    

                
            editLocalizedValue(
                value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/EditLocalizedValue', value,{}, showSpinner );

                    }
    }

export let LocalizedClient = new _LocalizedClient();

class _LoginClient {

    

                
            loginFromOnOffice(
                userId?:string,
                customerWebId?:string,
                apiClaim?:string,showSpinner = true): Promise<OM.LoginResponse> {
                        return CommonServices.defaultGet<OM.LoginResponse>(baseUrl + 'api/Login/LoginFromOnOffice',{ userId, customerWebId, apiClaim }, showSpinner);

                    }
    

                
            loginWithPassword(
                password?:string,showSpinner = true): Promise<OM.LoginResponse> {
                        return CommonServices.defaultGet<OM.LoginResponse>(baseUrl + 'api/Login/LoginWithPassword',{ password }, showSpinner);

                    }
    }

export let LoginClient = new _LoginClient();

class _MarketplaceClient {

    

                
            checkSignature(
                message?:string,
                signature?:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(baseUrl + 'api/Marketplace/CheckSignature',{ message, signature }, showSpinner);

                    }
    

                
            getSignature(
                message?:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(baseUrl + 'api/Marketplace/GetSignature',{ message }, showSpinner);

                    }
    

                
            activateMarketplace(
                userSecretKey?:string,
                apiToken?:string,
                apiClaim?:string,
                parameterCacheId?:string,
                userId?:string,
                customerWebId?:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/Marketplace/ActivateMarketplace',{ userSecretKey, apiToken, apiClaim, parameterCacheId, userId, customerWebId }, showSpinner);

                    }
    

                
            checkActivation(
                customerWebId?:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(baseUrl + 'api/Marketplace/CheckActivation',{ customerWebId }, showSpinner);

                    }
    }

export let MarketplaceClient = new _MarketplaceClient();

class _OnOfficeClient {

    

                
            getResources(
                customerWebId?:string,showSpinner = true): Promise<{ [key: string]: string; }> {
                        return CommonServices.defaultGet<{ [key: string]: string; }>(baseUrl + 'api/OnOffice/GetResources',{ customerWebId }, showSpinner);

                    }
    

                
            getGroups(
                customerWebId?:string,showSpinner = true): Promise<OM.GetGroupsResponse[]> {
                        return CommonServices.defaultGet<OM.GetGroupsResponse[]>(baseUrl + 'api/OnOffice/GetGroups',{ customerWebId }, showSpinner);

                    }
    

                
            getAllUsers(
                customerWebId?:string,showSpinner = true): Promise<OM.GetUserByEmailResponse[]> {
                        return CommonServices.defaultGet<OM.GetUserByEmailResponse[]>(baseUrl + 'api/OnOffice/GetAllUsers',{ customerWebId }, showSpinner);

                    }
    

                
            getAllUsersWithAuthStatus(
                customerWebId?:string,showSpinner = true): Promise<OM.UserWithAuthStatus[]> {
                        return CommonServices.defaultGet<OM.UserWithAuthStatus[]>(baseUrl + 'api/OnOffice/GetAllUsersWithAuthStatus',{ customerWebId }, showSpinner);

                    }
    }

export let OnOfficeClient = new _OnOfficeClient();

class _SyncConfigClient {

    

                
            getByWebUserId(
                webUserId?:string,showSpinner = true): Promise<OM.SyncConfig> {
                        return CommonServices.defaultGet<OM.SyncConfig>(baseUrl + 'api/SyncConfig/GetByWebUserId',{ webUserId }, showSpinner);

                    }
    

                
            save(
                item:OM.SyncConfig,showSpinner = true): Promise<OM.SyncConfig> {
                        return CommonServices.defaultPost<OM.SyncConfig>(baseUrl + 'api/SyncConfig/Save', item,{}, showSpinner );

                    }
    }

export let SyncConfigClient = new _SyncConfigClient();

class _SyncErrorClient {

    

                
            getByWebUserId(
                webUserId?:string,showSpinner = true): Promise<OM.SyncError[]> {
                        return CommonServices.defaultGet<OM.SyncError[]>(baseUrl + 'api/SyncError/GetByWebUserId',{ webUserId }, showSpinner);

                    }
    

                
            dismiss(
                identifier?:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/SyncError/Dismiss',{ identifier }, showSpinner);

                    }
    }

export let SyncErrorClient = new _SyncErrorClient();

class _SyncOperationsClient {

    

                
            sync(
                userId?:string,
                webUserId?:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/SyncOperations/Sync',{ userId, webUserId }, showSpinner);

                    }
    

                
            syncAll(
                webUserId?:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/SyncOperations/SyncAll',{ webUserId }, showSpinner);

                    }
    

                
            checkQuartzState(
                userId?:string,
                webUserId?:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(baseUrl + 'api/SyncOperations/CheckQuartzState',{ userId, webUserId }, showSpinner);

                    }
    

                
            firstSyncAll(
                vm:OM.FirstSyncVm,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultPost<boolean>(baseUrl + 'api/SyncOperations/FirstSyncAll', vm,{}, showSpinner );

                    }
    }

export let SyncOperationsClient = new _SyncOperationsClient();

class _UserClient {

    

                
            getUser(
                userId?:string,
                webUserId?:string,showSpinner = true): Promise<OM.User> {
                        return CommonServices.defaultGet<OM.User>(baseUrl + 'api/User/GetUser',{ userId, webUserId }, showSpinner);

                    }
    

                
            saveUserAuthorization(
                code?:string,
                redirectUri?:string,
                userId?:string,
                webUserId?:string,
                username?:string,showSpinner = true): Promise<OM.User> {
                        return CommonServices.defaultGet<OM.User>(baseUrl + 'api/User/SaveUserAuthorization',{ code, redirectUri, userId, webUserId, username }, showSpinner);

                    }
    

                
            revokeUser(
                userId?:string,
                webUserId?:string,showSpinner = true): Promise<OM.User> {
                        return CommonServices.defaultGet<OM.User>(baseUrl + 'api/User/RevokeUser',{ userId, webUserId }, showSpinner);

                    }
    

                
            save(
                user:OM.User,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(baseUrl + 'api/User/Save', user,{}, showSpinner );

                    }
    

                
            setSyncEnabled(
                identifier?:string,
                value?:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(baseUrl + 'api/User/SetSyncEnabled',{ identifier, value }, showSpinner);

                    }
    }

export let UserClient = new _UserClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}